import AuthorizationWrapper, {
  authFnAllowOnlySA,
} from '@product-framework/components/AuthorizationWrapper';
import { FORM_ACTION, getRoutes } from '@ui-framework/index';
import ClaimPaymentExportList from './pages/list/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';
import ClaimPaymentExportListStore from './store/index';

const Pages = ProtectedRoute => ({
  ClaimPaymentExportList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ClaimPaymentExportList}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySA],
      }}
      componentProps={{ action: FORM_ACTION.LIST }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  {
    claimPaymentExportListStore: new ClaimPaymentExportListStore(rootStore),
  },
];

export { ClaimPaymentExportList, routes, stores };
